<template>
  <footer class="footer_wrap hidden-xs-only">
    <div class="footer_container">
      <div class="footer_grid">
        <!-- Logo Section -->
        <div class="footer_col logo_col">
          <img :src="$brand.logo" :alt="$t('brand.logoAlt')" class="footer_main_logo" />
        </div>

        <!-- About Section -->
        <div class="footer_col brand_col">
          <h4 class="col_title brand_name">{{ $t('company.fullName') }}</h4>
          <p class="brand_desc">{{ $t('company.tagline') }}</p>
        </div>

        <!-- Resources Section -->
        <div class="footer_col">
          <h4 class="col_title">{{ $t('footer.contentCenter') }}</h4>
          <ul class="col_links">
            <li @click="handleToRouter('/news_detail/1')">{{ $t('footer.industryReports') }}</li>
          </ul>
        </div>

        <!-- Contact Section -->
        <div class="footer_col contact_col">
          <h4 class="col_title">{{ $t('footer.contactUs') }}</h4>
          <div class="contact_info">
            <p><i class="el-icon-location-outline"></i> {{ $t('footer.addressDetail') }}</p>
            <p><i class="el-icon-message"></i> <span @click="handleAccountEntry" class="clickable-email">{{ $t('footer.email') }}</span></p>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="copyright">{{ $t('footer.copyright') }}</div>
        <div v-if="$t('footer.icp')" class="icp">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('footer.icp') }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { isLoggedIn } from "@/utils/auth";

export default {
  methods: {
    handleAccountEntry() {
      const targetPath = isLoggedIn() ? "/controlCenter" : "/login";
      this.handleToRouter(targetPath);
    },
    handleToRouter(url) {
      this.$router.push(url).catch(() => {})
    },
    handleAccountClick() {
      this.handleToRouter(isLoggedIn() ? '/controlCenter' : '/login')
    },
  },
}
</script>

<style lang="scss" scoped>
.footer_wrap {
  width: 100%;
  background: #1a1e22;
  color: #fff;
  padding: 40px 0 20px 0;
  margin-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);

  .footer_container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 30px;
  }

  .footer_grid {
    display: grid;
    grid-template-columns: 80px 1fr 1fr 2fr;
    // gap: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    justify-items: center;
    text-align: center;
  }
  

  .footer_col {
    .col_title {
      font-size: 15px;
      font-weight: 700;
      // margin-bottom: 16px;
      color: rgba(255, 255, 255, 0.9);
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .col_links {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      li {
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
        margin-bottom: 12px;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          color: #03d2c5;
          transform: translateX(4px);
        }
      }
    }
  }

  .logo_col {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .footer_main_logo {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }

  .brand_col {
    .brand_name {
      font-size: 15px; // Matches .col_title
      font-weight: 700;
      // margin-bottom: 16px;
      color: rgba(255, 255, 255, 0.9);
      text-transform: uppercase;
      letter-spacing: 1px;
      // Optional gradient if you still want the brand name gradient:
      background: linear-gradient(134deg, #fff 0%, #03d2c5 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      display: inline-block;
    }
    .brand_desc {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.5;
      max-width: 250px;
    }
  }

  .contact_col {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contact_info {
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      display: flex;
      align-items: flex-start;
      // margin-bottom: 12px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.5;
      justify-content: center;
      i {
        margin-top: 3px;
        margin-right: 10px;
        color: #03d2c5;
        font-size: 16px;
      }
      .clickable-email {
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          color: #03d2c5;
        }
      }
    }
  }

  .footer_bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding-top: 16px;
    text-align: center;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.3);

    .icp {
      letter-spacing: 1px;
      a {
        color: inherit;
        text-decoration: none;
        transition: color 0.3s;
        &:hover {
          color: #03d2c5;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .footer_grid {
    grid-template-columns: 60px 2fr 1fr 2fr;
    gap: 20px;
  }
}
@media screen and (max-width: 768px) {
  .footer_grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .logo_col {
    justify-content: flex-start;
  }
}
</style>
